import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  movieId: string;
  variant?: "solid" | "outline";
}

export default function FavoriteButton({ movieId, variant = "outline" }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  const base =
    "flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-4 py-2.5 text-sm font-semibold transition-colors";
  const style = active
    ? "bg-accent-500 text-background-50 hover:bg-accent-600"
    : variant === "solid"
      ? "bg-primary-600 text-background-50 hover:bg-primary-700"
      : "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-400 hover:text-primary-700";

  return (
    <button type="button" onClick={() => toggleFavorite(movieId)} className={`${base} ${style}`}>
      <i className={`${active ? "ri-heart-fill" : "ri-heart-line"} text-lg`}></i>
      {active ? "已收藏" : "收藏"}
    </button>
  );
}